module.exports = __webpack_public_path__ + "media/game_end_3.0ef91f36.mp3";